@if (hasAccess() && menu?.length) {
  <div class="iris-header-settings">
    <div class="nav-item"
         [class.show]="menuDropdownTrigger.menuOpen"
         data-test="header-settings-button">
      <button class="nav-link"
              #menuDropdownTrigger="matMenuTrigger"
              [matMenuTriggerFor]="settingsMenu"
              [matTooltip]="'label.Settings' | translate"
              data-test="header-settings-settings-button">
        <i class="fas fa-lg fa-fw fa-cog"></i>
      </button>
      <mat-menu class="iris-dropdown-menu with-icon pt-2 pb-2"
                data-test="header-settings-menu"
                #settingsMenu="matMenu">
        <ul class="list-group">
          @for (item of menu; let first = $first; track item.id) {
            <li [ngClass]="{ 'dropdown-header': !item.url, 'mt-2': !first && !item.url }"
                class="level-{{ item.level }} mb-0"
                [attr.data-test]="item.dataTestAttr ? ('header-settings-' + item.dataTestAttr) : null">
              @if (!item.url) {
                <span>{{ item.title }}</span>

              } @else if (!getUi2SubPathOrNull(item.url)) {
                <a class="dropdown-item"
                  [href]="item.url"
                  data-test="header-settings-link">
                  <span class="item-title text-ellipsis">{{ item.title }}</span>
                  @if (item.hotkey) {
                    <span class="item-hotkey">{{ item.hotkey }}</span>
                  }
                </a>
              } @else {
                <a class="dropdown-item" [routerLink]="[getUi2SubPathOrNull(item.url)]" data-test="header-settings-link-2">
                  <span class="item-title text-ellipsis">{{ item.title }}</span>
                  @if (item.hotkey) {
                    <span class="item-hotkey">{{ item.hotkey }}</span>
                  }
                </a>
              }
            </li>
          }
        </ul>
      </mat-menu>
    </div>
  </div>
}
